<div
  class="mx-sm-5 mx-xs-3 my-sm-5 my-xs-3 building-management d-flex flex-column justify-content-center align-items-center h-100"
>
  <div class="text-container">
    <div class="icon-container ml-auto mr-auto mb-3">
      <img src="assets/svg/ico-building-gray.svg" class="building-icon" />
    </div>
    <div class="text-center mb-4">
      <h2 class="heading">{{ 'LETS_GET_STARTED' | translate }}</h2>
      <p class="heading-text">{{ 'LETS_GET_YOU_STARTED' | translate }}</p>
    </div>
  </div>
  <button
    class="add-button px-5 py-3"
    [controlDisabled]="[PageName.Building, CONSTANTS.CREATE]"
    (click)="openSiteModal()"
  >
    <strong>&nbsp;&nbsp; {{ 'ADD_BUILDING' | translate }}&nbsp;&nbsp;</strong>
  </button>
  <span class="mt-4">
    <div
      (click)="editSiteModal()"
      class="d-flex align-items-center pointer-cursor"
    >
      <img
        class="mb-4"
        src="assets/svg/ico-lock-access-settings.svg"
        alt="Lock Icon"
      />
      <div class="pl-3 text-item mb-3">
        <p class="heading-text">{{ 'EDIT_SITE_INFORMATION' | translate }}</p>
      </div>
    </div>
  </span>
</div>
